<template>
  <liste-documents
    :categorie="categorie"
    :title="$t('menu.documents.courrier')"
  />
</template>

<script>
export default {
  props: {
    categorie: {
      type: String,
    },
  },
}
</script>
